<div>
  <p class="scheduler-balloon_section__title"
    i18n="@@S_SCHEDULED_JOBS">Scheduled jobs</p>
  <fm-scheduler-balloon-section-item *ngFor="let scheduledJob of scheduledJobs"
    [scheduledJob]="scheduledJob"
    (scheduledJobClicked)="onScheduledJobClicked($event)"></fm-scheduler-balloon-section-item>
</div>